import React from 'react';
import { Badge } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';
import type { OpenShiftState } from '../../../components/Shifts/Common/types';
import {
  OPEN_SHIFT_STATE_VARIANT,
  getOpenShiftStateLabels,
} from '../components/openShiftConstants';

type Props = {
  name: string;
  targetName: string | null;
  state: OpenShiftState;
  breakPeriodMinutes: number;
};

export const OpenShiftEventContent: React.FC<Props> = ({
  name,
  targetName,
  state,
}) => {
  const t = useNamespacedTranslation('schedulerShifts.openShift');
  const stateLabel = getOpenShiftStateLabels(t);

  return (
    <div className="d-flex flex-column gap-1 p-1 h-100">
      <div className="d-flex align-items-center gap-1">
        <FlairIcon icon="people-outline" size="xs" />
        <span className="fw-bold text-truncate fs-5">{name}</span>
      </div>
      {targetName && <div className="fw-medium fs-5">@ {targetName}</div>}
      <div>
        <Badge bg={OPEN_SHIFT_STATE_VARIANT[state]} className="fs-6">
          {stateLabel[state]}
        </Badge>
      </div>
    </div>
  );
};
